import { SaveButton } from "components/Buttons"
import ImageEditor from "components/ImageEditor"
import { CheckboxField, TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  arrayPush,
  Field,
  FieldArray,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import { renderQuestionsForm } from "./utils"
import validate from "./formBuilderValidation"
import {
  addFormBuilder,
  displayLockWarningModal,
  getFormBuilder,
  resetFormBuilder,
  updateFormBuilder,
} from "store/actions"
import { mapApiToFormBuilder, mapFormBuilderToApi } from "../utils"
import PropTypes from "prop-types"
import Preview from "./preview"

const QuestionsTab = props => {
  const handleFieldFocus = event => {
    if (props?.hasReplies) {
      event.preventDefault()
      props.displayLockWarningModal()
    }
  }

  return (
    <Card>
      <CardBody>
        <Row>
          <Col>
            <h3>{props.feature.label}</h3>
          </Col>
          {props.isListItem && (
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Cancel"
                color="light"
                onClick={props.backButtonHandler}
              />
            </Col>
          )}
          <Col xs="auto">
            <SaveButton
              content="Save"
              type="button"
              onClick={props.handleSave}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Row className="mt-3 mb-1">
              <Col xs={12}>
                <Field
                  name="includeResponses"
                  component={CheckboxField}
                  label="Include Responses in Email"
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12}>
                <Field
                  name="retake"
                  component={CheckboxField}
                  label="Allow retakes"
                />
              </Col>
            </Row>
            {props.retake && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="retakeText"
                    component={TextField}
                    label="Retake Button Text"
                  />
                </Col>
              </Row>
            )}
            <Row className="my-3">
              <Col>
                <Field
                  name="image"
                  component={ImageEditor}
                  onDelete={() =>
                    props.change("form_builder_form.deleteImage", true)
                  }
                  label="Image"
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col>
                <Field
                  name="description"
                  component={TextField}
                  label="Description"
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col xs={"auto"} xl={3} style={{ minWidth: "fit-content" }}>
                <Field
                  name="requirePayment"
                  component={CheckboxField}
                  label="Require Payment"
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col>
                <Field
                  name="price"
                  component={TextField}
                  disabled={!props.requirePayment}
                  label="Price($)"
                />
              </Col>
            </Row>
            {props.isListItem && (
              <Card>
                <CardHeader>
                  <h4>CREATE A NAME FOR YOUR FORM BUILDER</h4>
                </CardHeader>
                <CardBody>
                  <Row className="mb-2">
                    <Col>
                      <Field name="name" component={TextField} label="Name" />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
            <Card>
              <CardHeader>
                <h4>FORM BUILDER QUESTIONS</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs={12}>
                    Create your Form Builder questions and give answer choices.
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <FieldArray
                      name="questions"
                      component={renderQuestionsForm}
                      handleFieldFocus={handleFieldFocus}
                      hasReplies={props?.hasReplies}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <h5
                      style={{ cursor: "pointer" }}
                      onClick={
                        props?.hasReplies
                          ? () => {}
                          : () => {
                              props.addForm(
                                FORM_NAMES.FORM_BUILDER,
                                "form_builder_form.questions",
                                {
                                  id: null,
                                  answerType: "1",
                                  answers: [
                                    { id: null, answer: "" },
                                    { id: null, answer: "" },
                                  ],
                                  textAnswerType: "1",
                                }
                              )
                            }
                      }
                    >
                      + Add Another Form Builder Question
                    </h5>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Row className="my-2">
              <Col className="d-flex justify-content-center">
                <SaveButton
                  type="button"
                  content="Save"
                  onClick={props.handleSave}
                />
              </Col>
            </Row>
          </Col>
          <Col xl={4} className="mt-4 custom-features-preview">
            <Preview
              menu_bg_color={props.design?.menu_bg_color}
              menu_font_color={props.design?.menu_font_color}
              label={props.formValues?.name || props.feature.label}
              image={props.formValues?.image?.editedImage}
              description={props.formValues?.description}
              questions={props.formValues?.questions}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const selector = formValueSelector(FORM_NAMES.FORM_BUILDER)

const mapStateToProps = state => ({
  retake: selector(state, "form_builder_form.retake"),
  questions: selector(state, "form_builder_form.questions"),
  answerType: selector(state, "form_builder_form.answerType"),
  formBuilder: state.FormBuilder.formBuilder,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  formValues: selector(state, "form_builder_form"),
  requirePayment: selector(state, "form_builder_form.requirePayment"),
})

const mapDispatchToProps = dispatch => ({
  addForm: (form, field, values) => dispatch(arrayPush(form, field, values)),
  getFormBuilder: values => dispatch(getFormBuilder(values)),
  resetFormBuilder: () => dispatch(resetFormBuilder()),
  initializeForm: values =>
    dispatch(
      initialize(FORM_NAMES.FORM_BUILDER, {
        form_builder_form: values,
      })
    ),
  addFormBuilder: (questions, params) =>
    dispatch(addFormBuilder(questions, params)),
  updateFormBuilder: (questions, params, entity_id) =>
    dispatch(updateFormBuilder(questions, params, entity_id)),
  displayLockWarningModal: () => dispatch(displayLockWarningModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(QuestionsTab)
